import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { hiveIdSchema } from "./hiveSchema";

export const observationIdPrefix = "obs_";
export type ObservationId = ID<typeof observationIdPrefix>;
export const generateObservationId = makeIdGenerator(observationIdPrefix);
export const observationIdSchema = getIdSchema(
  observationIdPrefix,
  "ObservationId",
);

export const observationSchema = z
  .object({
    id: observationIdSchema,
    hiveId: hiveIdSchema,
    startedAt: z.coerce.date(),
    finishedAt: z.coerce.date().nullable(),
    type: z.enum(["on_flow", "declining", "offline", "low_battery"]),
  })
  .meta({ id: "Observation" });

export type Observation = z.infer<typeof observationSchema>;
